import { tv } from 'tailwind-variants';

const rootStyles = tv({
  base: 'relative',
});

const containerStyles = tv({
  base: 'fixed z-[120]',
  variants: {
    position: {
      top: '',
      bottom: '',
      left: 'mr-5',
      right: 'ml-5',
      'top-left': 'mr-5',
      'top-right': 'ml-5',
      'bottom-left': 'mr-5',
      'bottom-right': 'ml-5',
    },
  },
});

const contentStyles = tv({
  base: 'min-w-[160px] max-w-max tracking-wide transition-all ease-in-out absolute p-4 rounded-md before:content-[" "] before:w-2 before:h-2 before:rotate-45 before:absolute',
  variants: {
    design: {
      primary:
        'bg-gradient-to-r from-primary-one to-primary-two before:bg-gradient-to-r before:from-primary-one before:to-primary-two text-white',
      secondary: 'bg-secondary-one before:bg-secondary-one text-white',
      'secondary-dark': 'bg-secondary-two before:bg-secondary-two text-white',
      outline:
        'bg-white border before:bg-white before:border before:border-secondary-two border-secondary-two',
    },
    isOpened: {
      false: 'invisible',
      true: 'visible',
    },
    position: {
      top: '-top-2.5 left-1/2 -translate-x-1/2 -translate-y-full before:-bottom-1  before:left-1/2 before:-translate-x-1/2',
      bottom:
        '-bottom-2.5 left-1/2 -translate-x-1/2 translate-y-full before:-top-1 before:left-1/2 before:-translate-x-1/2',
      left: '-left-2 top-1/2 -translate-y-1/2 -translate-x-full before:-right-1 before:top-1/2 before:-translate-y-1/2',
      right:
        '-right-2 top-1/2 -translate-y-1/2 translate-x-full before:-left-1 before:top-1/2 before:-translate-y-1/2',
      'top-left':
        '-top-2.5 left-6 -translate-y-full -translate-x-full before:-bottom-1 before:right-2.5',
      'top-right':
        '-top-2.5 right-6 -translate-y-full translate-x-full before:-bottom-1 before:left-2.5',
      'bottom-left':
        '-bottom-2.5 left-6 translate-y-full -translate-x-full before:-top-1 before:right-2.5',
      'bottom-right':
        '-bottom-2.5 right-6 translate-y-full translate-x-full before:-top-1 before:left-2.5',
    },
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      lg: 'text-lg',
      xl: 'text-xl',
    },
  },
});

export const tooltipStyles = {
  root: rootStyles,
  container: containerStyles,
  content: contentStyles,
};
